import { useEffect, useMemo, useState, useContext } from "react";
import { Marker } from "react-leaflet";
import L from "leaflet";
import LgvIcon from "../LgvIcon/LgvIcon"; // Import your LgvIcon component or whatever icon component you use
import {
  mapCoordinate,
  convertReactComponentToHtmlIcon,
  lgvNameRenderer,
  statusColorRenderer
} from "../../util/helper/helperFunctions";
import { useSelector } from "react-redux";
import { AppContext } from "../../Context/Context";
import useMinimizedModalFeature from "../../hooks/useMinimizedModalFeature";
import MaxZoomLGVIcon from "../LgvIcon/MaxZoomLGVIcon";

const RenderLgv = ({ mapObject, lgvData, plantConfig,zoomLevel,maxZoom }) => {
  const {
    setIsMarkerPopupOpen,
    setSelectedMarkerType,
    setSelectedMarkerData,
    openedLgvVehichleNumber
  } = useContext(AppContext);

  const [convertedData, setConvertedData] = useState([]);

  const { feature } = useMinimizedModalFeature();

  const { followingLgvList } = useSelector((state) => state.plant);

  useEffect(() => {
    if (lgvData) {
      timeMachineLgvCoordinateConverter(lgvData);
    }
  }, [lgvData]);

  const timeMachineLgvCoordinateConverter = (lgvData) => {
    //Get LGV bounds from Plant Config
    if (plantConfig) {
      const { lgvs } = plantConfig.indoorMap;
      const { bounds } = lgvs;

      if (mapObject && lgvData.length) {
        // let filteredData = filterDuplicatesAndNoCoordinates(lgvData);
        lgvData.map((marker, index) => {
          let convertedCoordinates = mapCoordinate(
            marker["longitude"],
            marker["latitude"],
            "lgv",
            bounds
          );
          let convertedPoints = L.point(
            convertedCoordinates.x,
            convertedCoordinates.y
          );
          let convertedLatLng =
            mapObject.map.target.layerPointToLatLng(convertedPoints);
          marker.currentPos = {
            lat: convertedLatLng.lat,
            lng: convertedLatLng.lng
          };
        });
        setConvertedData(lgvData);
      }
    }
  };

  const markers = useMemo(() => {
    if (plantConfig && convertedData && Array.isArray(convertedData)) {
      // Get Plant's LGV Config
      const { lgvs } = plantConfig.indoorMap;
      // LGV's Marker and Group offset values
      const {
        marker,
        groupOffset,
        marker: { size }
      } = lgvs;

      return convertedData.map((lgvMarker, index) => {
        // Check if this LGV is being followed
        const isLgvBeingFollowed = followingLgvList[feature]?.find(
          (lgv) => lgv.vehicleNumber === lgvMarker.vehicleNumber
        );

        let markerData = lgvMarker;
        lgvNameRenderer(markerData.vehicleNumber?.toString());

        if (markerData.vehicleNumber?.toString() == openedLgvVehichleNumber) {
          setSelectedMarkerData(markerData);
        }

        // Convert React component to HTML icon
        const reactIcon = convertReactComponentToHtmlIcon(
          zoomLevel === maxZoom ? (
            <MaxZoomLGVIcon
              color={statusColorRenderer(lgvMarker.status)}
              angle={lgvMarker.angle}
              vehicleNumber={lgvMarker.vehicleNumber}
              isFollowing={isLgvBeingFollowed}
            />
          ) : (
            <LgvIcon
              data={lgvNameRenderer(lgvMarker.vehicleNumber)}
              status={lgvMarker.status}
              isFollowing={isLgvBeingFollowed}
              initialWidth={size?.[0]}
            />
          ),
          "lgv-icon",
          size,
          [40.5, 48] // this should have been [0, 0] and aligned through bounds from config
        );

        const lgvCorrection = groupOffset;

        return (
          <Marker
            type="lgv"
            data={markerData}
            eventHandlers={{
              click: () => {
                setSelectedMarkerData(markerData);
                setSelectedMarkerType("lgv");
                setIsMarkerPopupOpen(true);
              }
            }}
            key={index}
            riseOnHover
            position={[
              markerData.currentPos.lat + lgvCorrection.x,
              markerData.currentPos.lng + lgvCorrection.y
            ]}
            icon={reactIcon}
          />
        );
      });
    }
    return null;
  }, [
    convertedData,
    followingLgvList,
    plantConfig,
    setSelectedMarkerData,
    setSelectedMarkerType,
    feature
  ]);

  return <>{markers}</>;
};

export default RenderLgv;
